/**
 * @since 2026-04-20
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import "./ValidateIssueDialog.scss";

const ValidateIssueDialog = ({ open, issue, onConfirm, onCancel }) => {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className="validateIssueDialog"
      PaperProps={{ className: "dialogPaper" }}
    >
      <DialogTitle className="dialogTitle">
        <Typography variant="h6" component="div">Validate issue</Typography>
      </DialogTitle>
      <DialogContent className="dialogContent">
        {issue?.label && (
          <Typography variant="body2" className="issueLabel">{issue.label}</Typography>
        )}
        <Typography variant="body2" className="helperText">
          Marking this issue as validated tells future runs to treat it as a known, acceptable finding.
        </Typography>
        <TextField
          className="reasonField"
          label="Reason (optional)"
          placeholder="e.g. expected vendor outage"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={2}
          fullWidth
          variant="outlined"
          autoFocus
        />
      </DialogContent>
      <DialogActions className="dialogActions">
        <Button onClick={onCancel} className="cancelButton">Cancel</Button>
        <Button
          onClick={() => onConfirm(reason, false)}
          className="confirmButton"
          variant="outlined"
        >
          Validate
        </Button>
        <Button
          onClick={() => onConfirm(reason, true)}
          className="confirmButton primary"
          variant="contained"
        >
          Validate &amp; Run
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidateIssueDialog;
